module.exports = __webpack_public_path__ + "static/img/8b.ecb5ba9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/8b.jpg
// module id = SdZD
// module chunks = 1